import { ImgHTMLAttributes } from 'react';

/**
 * @deprecated use icons from '@frontend/legacy-components' instead.
 */
export const OldFileIcon = (props: ImgHTMLAttributes<HTMLImgElement>) => (
  <img
    {...props}
    src={'https://s3.amazonaws.com/static.digital-quote.com/icons/file.svg'}
    alt="Other File"
  />
);
/**
 * @deprecated use icons from '@frontend/legacy-components' instead.
 */
export const OldPdfIcon = (props: ImgHTMLAttributes<HTMLImgElement>) => (
  <img
    {...props}
    src={'https://s3.amazonaws.com/static.digital-quote.com/icons/pdf4.svg'}
    alt="PDF File"
  />
);

export type PartThumbnailFallbackProps = {
  isPdf: boolean;
};

export const PartThumbnailFallback = ({
  isPdf,
}: PartThumbnailFallbackProps) => {
  return isPdf ? (
    <OldPdfIcon
      style={{
        height: 'auto',
        maxHeight: '100%',
        maxWidth: '100%',
        objectFit: 'cover',
        verticalAlign: 'middle',
        width: 'fit-content',
      }}
    />
  ) : (
    <OldFileIcon
      style={{
        height: 'auto',
        maxHeight: '100%',
        maxWidth: '100%',
        objectFit: 'cover',
        width: 'fit-content',
        verticalAlign: 'middle',
      }}
    />
  );
};
